export const { VITE_API_URL: API_URL } = import.meta.env;
